import {getCurrentYear} from '../../utils/commons'
import BestReviewsOnlineLogo from './logo'
import {bestReviewsOnlineStylesCA, bestReviewsOnlineStylesUK} from './styles'

const baseConfig = {
  domainName: 'bestreviewsonline' as const,
  domainType: 'picks' as const,
  siteName: 'Best Reviews Online',
  favicon: '/favicons/bestreviewsonline.png',
}

const localeConfigs = {
  uk: {
    measurementId: 'G-G6DZW0EFWR',
    camelCaseUrl: 'BestReviewsOnline.co.uk',
    logo: <BestReviewsOnlineLogo className="size-10 shrink-0 tablet:size-8" locale="uk" />,
    styles: bestReviewsOnlineStylesUK,
    title: (category: string, count: string) =>
      `${count} Best  ${category} ${getCurrentYear()} in the UK | There's One Clear Winner | BestReviewsOnline.co.uk`,
    description: (_category?: string, _count?: string) =>
      `BestReviewsOnline.co.uk – Expert reviews on thousands of products. Discover top-rated items at today's lowest prices, all in one place!`,
  },
  ca: {
    measurementId: 'G-1R6X0MT8ZG',
    camelCaseUrl: 'BestReviewsOnline.ca',
    logo: <BestReviewsOnlineLogo className="size-10 shrink-0 tablet:size-8" locale="ca" />,
    styles: bestReviewsOnlineStylesCA,
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in CA | There's One Clear Winner | BestReviewsOnline.ca`,
    description: (_category?: string, _count?: string) =>
      `BestReviewsOnline.ca – Expert reviews on thousands of products. Discover top-rated items at today's lowest prices, all in one place!`,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.uk
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
